function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("radialGradient", {
  id: "a"
}, React.createElement("stop", {
  offset: "50%",
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#fff",
  stopOpacity: 0
})), React.createElement("mask", {
  id: "b"
}, React.createElement("path", {
  fill: "url(#a)",
  d: "M0 0h672v274H0z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#E1E8EF",
  d: "M0 251.7h671.2M0 210h671.2M0 168.2h671.2M0 126.5h671.2M0 84.5h671.2M0 42.9h671.2M0 1h671.2M39.4 1v271.7M89 1v271.7M138.8 1v271.7M188.6 1v271.7M238.2 1v271.7M288 1v271.7M337.7 1v271.7M387.4 1v271.7M437 1v271.7M486.9 1v271.7M536.6 1v271.7M586.3 1v271.7M636 1v271.7",
  mask: "url(#b)"
});

var SvgPlaceholderChart = function SvgPlaceholderChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 672,
    height: 274,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlaceholderChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/placeholderChart.97dc51cf.svg";
export { ForwardRef as ReactComponent };